import { createFileRoute } from "@tanstack/react-router";
import { canonicalLink, pathFromMatch, routeMeta } from "@/lib/seo";
import { cityHeadScripts } from "@/lib/cityJsonLd";
import { CityHomePage } from "@/components/CityHomePage";
import hero from "@/assets/original/hero-shade.jpg";

export const Route = createFileRoute("/katy")({
  head: (ctx) => ({
    links: [canonicalLink(pathFromMatch(ctx))],
    meta: routeMeta(ctx, {
      title: "Custom Awnings, Covers & Shade in Katy, TX | Texas Made Shade",
      description: "Custom welded awnings, sail shades, patio & pergola covers, marine canvas and aluminum fabrication for Katy & Harris County. Free quotes — +1 (830) 390-9588.",
      image: hero,
      socialTitle: "Custom Awnings & Shade — Katy, TX",
      socialDescription: "Welded aluminum + Sunbrella canvas. Custom shade, covers and fabrication serving Katy and Harris County.",
      keywords: "awnings Katy, awning company Katy, custom awnings Katy, sail shades Katy, patio covers Katy, pergola covers Katy, metal awnings Katy, canvas awnings Katy, Texas Made Shade",
    }),
    scripts: cityHeadScripts("Katy", "Harris County"),
  }),
  component: () => <CityHomePage city="Katy" region="Harris County" />,
});
